import React, { useState } from "react";
import { Badge, Button, Modal, OutOfPolicyBadge } from "../../../../../../../../Components";
import { useUserConfig } from "../../../../../../../../Hooks/useUserConfig";
import { formatedPrice } from "Utils/utils";

function Fare({ selected, flight, fare, familyFare, onSelect, approval }) {
	const { checkUserPermission } = useUserConfig();
	const approvedAmount = approval?.amount;
	const { fareKey, price, inPolicy, violations, currency, includedServices, bundledServiceName } = fare;
	const active = selected && selected.selectedFare.fareKey === fareKey && selected.selectedFare.price === price;
	const askApproval = !inPolicy && !checkUserPermission("TA") && (approvedAmount ? price > Number(approvedAmount) : true);

	const [ShowServices, setShowServices] = useState(false);

	if (price > 0)
		return (
			<>
				<div className="flex flex-col justify-between flex-1 h-full min-w-[10rem] gap-2 p-3 md:p-4 m-auto text-center flex-center shrink-0">
					{askApproval ? <OutOfPolicyBadge violations={[...violations]} /> : <></>}
					{bundledServiceName && (
						<p className="min-h-[2.5rem] text-[13px] leading-5 font-bold uppercase whitespace-normal break-words">
							{bundledServiceName}
						</p>
					)}
					{includedServices?.length > 0 && (
						<div className="relative inline-block">
							<Badge onClick={() => setShowServices(true)} className="text-xs cursor-pointer">
								Included Perks
							</Badge>
						</div>
					)}
					<p className="text-lg font-bold text-nowrap">
						{currency} {formatedPrice(price)}
					</p>
					{onSelect &&
						(active ? (
							<Button disabled className="btn-sm mt-2 border border-success/60 bg-success/5 text-success cursor-default">
								Selected Fare
							</Button>
						) : (
							<Button onClick={() => onSelect(fare)} variant="primary" className="btn-sm mt-2">
								Select Fare
							</Button>
						))}
				</div>
				<Modal open={ShowServices} onClose={() => setShowServices(false)}>
					<div className="p-4">
						<h3 className="my-4">🚀 What's included in this fare</h3>
						<ul className="space-y-2">
							{includedServices?.map((service) => (
								<Badge key={service}>{service.replace(/[^\x20-\x7Eáéíóúñ]/g, "")}</Badge>
							))}
						</ul>
					</div>
				</Modal>
			</>
		);
	return null;
}

export default Fare;
